module.exports = __webpack_public_path__ + "img/GRADER.709fdfc4.svg";